import { NgModule, inject, provideAppInitializer } from '@angular/core';
import {
    MissingTranslationHandler,
    TranslateDirective,
    TranslatePipe,
    TranslateService,
    provideTranslateService
} from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { catchError, firstValueFrom, of } from 'rxjs';
import { MyMissingTranslationHandler } from './shared/handler/missingtranslation.handler';

@NgModule({
    exports: [TranslatePipe, TranslateDirective],
    imports: [TranslatePipe, TranslateDirective],
    providers: [
        provideTranslateService({
            loader: provideTranslateHttpLoader({ prefix: '/assets/i18n/', suffix: '.json' }),
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: MyMissingTranslationHandler
            },
            fallbackLang: 'en'
        }),
        // ngx-translate 18 resolves keys synchronously. Without waiting for the first language file,
        // components rendered early (e.g. loading indicators) would briefly show raw translation keys.
        provideAppInitializer(() => {
            const translateService = inject(TranslateService);
            return firstValueFrom(translateService.use('en').pipe(catchError(() => of(null))));
        })
    ]
})
export class TranslateRootModule {}
